import { render, staticRenderFns } from "./accounts-add.vue?vue&type=template&id=507ea2d0&scoped=true"
import script from "./accounts-add.vue?vue&type=script&lang=js"
export * from "./accounts-add.vue?vue&type=script&lang=js"
import style0 from "./accounts-add.vue?vue&type=style&index=0&id=507ea2d0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507ea2d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('507ea2d0')) {
      api.createRecord('507ea2d0', component.options)
    } else {
      api.reload('507ea2d0', component.options)
    }
    module.hot.accept("./accounts-add.vue?vue&type=template&id=507ea2d0&scoped=true", function () {
      api.rerender('507ea2d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/pbc-management/accounts-add.vue"
export default component.exports